<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane active" id="activity">
            <h2>General Information</h2>
            <div class="row">
              <div class="form-group col-md-4">
                <label class="form-label">Client Code</label>
                <input type="text" class="form-control" v-model="form.BP_CODE_NEW" readonly />
              </div>
              <div class="form-group col-md-8">
                <label class="form-label">Client</label>
                <input type="text" class="form-control" v-model="form.BP_DSC" />
              </div>
              <!--<div class="form-group col-md-2">
                <label class="form-label">Branch</label>
                <v-select placeholder="--Select--" label="Title" :options="branches" v-model="form.BRANCH_ID" :reduce="x => x.ID" />
              </div>-->
              <div class="form-group col-md-12">
                <label class="form-label">Address<span style="color: red;">(Incase of Multiple Addresss)</span></label>
                <table class="col-md-12 table-sm table-bordered">
                  <thead class="bg-custom">
                    <tr>
                      <th>Sr.No</th>
                      <th>Address</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(address, index) in addresses" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <input class="form-control" v-model="address.ADD_ADDRESS" placeholder="Enter address" required />
                      </td>
                      <td>
                        <input type="checkbox" v-model="address.ADD_ISACTIVE" :true-value="1" :false-value="0" />
                        {{ address.ADD_ISACTIVE ? 'Active' : 'Inactive' }}
                      </td>
                      <td>
                        <button type="button" class="btn btn-danger" @click="removeAddress(index)" :disabled="addresses.length === 1">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">
                        <button type="button" class="btn btn-block btn-secondary" @click="addAddress">
                          Please press button to Add Multiple Address
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <h2>Personal Information</h2>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="form-label">Father/Husband's Name</label>
                <input type="text" class="form-control" v-model="form.BP_FATHER_HUSBANDNAME" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Mother's Maiden Name</label>
                <input type="text" class="form-control" v-model="form.BP_MOTHERNAME" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Gender</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Male', value: 'M' },{ label: 'Female', value: 'F' }]" v-model="form.BP_IFINDVGENDER" label="label" :reduce="option => option.value" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Tax Payer</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Yes', value: '1' },{ label: 'No', value: '0' }]" v-model="form.BP_ISACTTAXPAY" label="label" :reduce="option => option.value" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Landline</label>
                <input type="text" class="form-control" minlength="11" maxlength="11" v-model="form.BP_UAN" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Cell No.</label>
                <input type="text" class="form-control" minlength="11" maxlength="11" v-model="form.BP_MOBILE" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Email Id</label>
                <input type="email" class="form-control" v-model="form.BP_EMAIL_ADDRESS" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Date of Birth</label>
                <input type="date" class="form-control" v-model="form.BP_DOB" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Place of Birth</label>
                <input type="text" class="form-control" v-model="form.BP_PLACEOFBIRTH" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Resident or Not</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Yes', value: '1' },{ label: 'No', value: '0' }]" v-model="form.BP_ISRESEDENT" label="label" :reduce="option => option.value" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">N.T.N</label>
                <input type="text" class="form-control" v-model="form.BP_NTN_NO" minlength="7" maxlength="9" pattern="[A-Za-z0-9]{7,9}" title="NTN must contain 7 to 9 letters or digits" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">CNIC No.</label>
                <input type="text" class="form-control" v-mask="'#####-#######-#'" v-model="form.BP_NIC_NO" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">CNIC/Passport Issue Date</label>
                <input type="date" class="form-control" v-model="form.BP_CNICISSUEDATE" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">CNIC/Passport Expiry Date</label>
                <input type="date" class="form-control" v-model="form.BP_CNIC_EXPIRYDATE" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Passport No.</label>
                <input type="text" class="form-control" maxlength="9" v-model="form.BP_PASSPORTNO" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Verification</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Yes', value: 'Y' },{ label: 'No', value: 'N' }]" v-model="form.BP_CNICVARIFICATINO" label="label" :reduce="option => option.value" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Country</label>
                <v-select placeholder="--Select--" label="Title" :options="countries" v-model="form.C_CODE" :reduce="x => x.ID" @input="fetchStates" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">State</label>
                <v-select placeholder="--Select--" label="Title" :options="states" v-model="form.PVN_ID" :reduce="x => x.ID" @input="fetchCities" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">City</label>
                <v-select placeholder="--Select--" label="Title" :options="cities" v-model="form.CTY_ID" :reduce="x => x.ID" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">Active</label><br />
                <input type="checkbox" v-model="form.BP_ACTIVE" />
              </div>
            </div>

            
            <h2>Business Information</h2>
            <div class="row">
              <div class="form-group col-md-6">
                <label class="form-label">Nature of Business</label>
                <input type="text" class="form-control" v-model="form.BP_BUSINESSNAME" />
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Business Address</label>
                <input type="text" class="form-control" v-model="form.BP_BUSINESSADDRESS" />
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Main Geographically Within Pakistan (Specify)</label>
                <input type="text" class="form-control" v-model="form.BP_MAINGAOAWITHINPAK" />
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Outside Pakistan (Specify)</label>
                <input type="text" class="form-control" v-model="form.BP_OUTSIDEPAKACTIVITY" />
              </div>
            </div>
            <h2>Politically Exposed Person (PEP) Details</h2>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="form-label">PEP (Yes/No)</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Yes', value: 'Yes' },{ label: 'No', value: 'No' }]" v-model="form.BP_PEP" label="label" :reduce="option => option.value" />
                <!--<select class="form-control" v-model="form.BP_PEP">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>-->
              </div>
              <div class="form-group col-md-3">
                <label class="form-label">If Yes, Nature</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Domestic PEP', value: 'DOM' },{ label: 'Foreign PEP', value: 'FOR' }]" v-model="form.BP_DOMESTICPEP" label="label" :reduce="option => option.value" />
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">If Yes, Self Position/Status</label>
                <input type="text" class="form-control" v-model="form.BP_IFPEPPOSITIONSTATUS" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label class="form-label">If Yes, By Way of Association/Relationship</label>
                <input type="text" class="form-control" v-model="form.BP_IFPEPBYWAOFACC_RELATION" />
              </div>
              <div class="form-group col-md-6">
                <label class="form-label">Position Held</label>
                <input type="text" class="form-control" v-model="form.BP_POSITIONHELD" />
              </div>
            </div>
            <h2>Source Of Income</h2>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="form-label">Source of Income</label>
                <v-select placeholder="--Select--" :options="[{ label: 'Salary', value: 'Salary' },{ label: 'Private Job', value: 'Private Job' },{ label: 'Other', value: 'Other' }]" v-model="form.BP_SOURCEOFINCOME" label="label" :reduce="option => option.value" />
                <!--<select class="form-control" v-model="form.BP_SOURCEOFINCOME">
                  <option value="Salary">Salary</option>
                  <option value="Private Job">Private Job</option>
                  <option value="Other">Other</option>
                </select>-->
              </div>
              <div class="form-group col-md-9">
                <label class="form-label">Other (Specify)</label>
                <input type="text" class="form-control" v-model="form.BP_SOURCEOFINCOME_SPFY" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="submit" class="btn btn-success float-right mr-1">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        addresses: [{
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        }],
        ALLOTMENT: [{
          BA_ID: null,
          BP_ID: null,
          BA_BRANCH: '',
          BA_ISACTIVE: 1
        }],
        form: {
          BP_ID: this.clientid,
          BP_DSC: '',
          BP_ADDRESS: '',
          BRANCH_ID: '', 
          C_CODE: '',
          PVN_ID: '',
          CTY_ID: '',
          BP_ACTIVE: true,
          BP_MOBILE: '',
          BP_GST_NO: '',
          BP_NIC_NO: '',
          BP_NTN_NO: '',
          BP_FATHER_HUSBANDNAME: '',
          BP_MOTHERNAME: '',
          BP_IFINDVGENDER: '',
          BP_ISACTTAXPAY: '',
    /*      str: '',*/
          BP_UAN: '',
          BP_EMAIL_ADDRESS: '',
          BP_DOB: '',
          BP_PLACEOFBIRTH: '',
          BP_ISRESEDENT: '',
          BP_PASSPORTNO: '',
          BP_CNICVARIFICATINO: '',
          BP_CNICISSUEDATE: '',
          BP_CNIC_EXPIRYDATE: '',
          BP_BUSINESSNAME: '',
          BP_BUSINESSADDRESS: '',
          BP_MAINGAOAWITHINPAK: '',
          BP_OUTSIDEPAKACTIVITY: '',
          BP_PEP: '',
          BP_IFPEPYESSELF: '',
          BP_DOMESTICPEP: '',
          BP_IFPEPPOSITIONSTATUS: '',
          BP_IFPEPBYWAOFACC_RELATION: '',
          BP_POSITIONHELD: '',
          BP_SOURCEOFINCOME: '',
          BP_SOURCEOFINCOME_SPFY: '',
          BP_CODE_NEW: '',
        },
        client: {},
        branches: [],
        taxes: [],
        countries: [],
        states: [],
        cities: [],
      };
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/pageloadAdvanceClientProfile?id=" + vm.clientid)
          .then(function (res) {
            endReq();
            vm.branches = res.data.branches || [];
            vm.taxes = res.data.taxes || [];
            vm.countries = res.data.countries || [];
            vm.states = res.data.states || [];
            vm.cities = res.data.cities || [];
            vm.form = res.data.obj;
            vm.addresses = res.data.ADDRESSES;
           
          })
          .catch((error) => {
            endReq();
            console.error("API Error:", error);
            
          });
      },
      fetchStates() {
        var vm = this;
        axios.get('/api/UICApi/loadStates?countryId=' + vm.form.C_CODE)
          .then(function (res) {
            endReq();
            vm.states = res.data.states;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          });
      },
      fetchCities() {
        var vm = this;
        axios.get('/api/UICApi/loadCities?stateId=' + vm.form.PVN_ID)
          .then(function (res) {
            endReq();
            vm.cities = res.data.cities;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          });
      },
      addAddress() {
        this.addresses.push({
          ADD_ID: null,
          BP_ID: null,
          ADD_ADDRESS: '',
          ADD_ISACTIVE: 1
        });
      },
      removeAddress(index) {
        if (this.addresses.length > 1) {
          this.addresses.splice(index, 1);
        }
      },
      handleSubmit() {
        var vm = this;
        startReq();
        axios.post("/api/UICApi/updateAdvanceClientProfile", {
          BPMain: vm.form,
          Address : vm.addresses,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Client profile updated successfully!");
            }
            else {
              toastr.error("Failed to update client profile: " + res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
            console.log(error);
            toastr.error("An error occurred while updating the profile.");
          });
      },
    },
  };
</script>
<style>
  h2 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
    border-bottom: 2px solid #4CAF50;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/AdvanceClientProfile.vue